<template>
  <div>
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
      <span>{{ $t('admin.appointment.detail.back') }}</span>
    </div>
    <a-form :form="form" layout="vertical">
      <div class="title">{{ $t('admin.appointment.detail.basicInfo') }}</div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.appointment.detail.theme.label')" :colon="false">
          <a-input
            disabled
            v-decorator="['theme', { rules: [{ required: true }] }]" ></a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.appointment.detail.trainingRoom.label')" :colon="false">
          <a-input
            disabled
            v-decorator="['trainingRoomName', { rules: [{ required: true }] }]" ></a-input>
        </a-form-item>
      </div>
      <div class='list'>
        <a-form-item class="full" :label="$t('admin.appointment.detail.trainingRoom.place')" :colon="false">
          <a-input
            disabled
            v-decorator="['trainingRoomPlace', { rules: [{ required: true }] }]" ></a-input>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.appointment.detail.appointmentTime.label')" :colon="false">
          <a-input
            disabled
            v-decorator="['reservationAt', { rules: [{ required: true }] }]" ></a-input>
        </a-form-item>
      </div>
      <div class='list'>
        <a-form-item class="full" :label="$t('admin.appointment.detail.status.label')" :colon="false">
          <a-input
            disabled
            v-decorator="['statusName', { rules: [{ required: true }] }]" ></a-input>
        </a-form-item>
        <a-form-item v-show='status==3' class="full" :label="$t('admin.appointment.detail.approval.label')" :colon="false">
          <a-input
            disabled
            v-decorator="['approval', { rules: [{ required: true }] }]" ></a-input>
        </a-form-item>
      </div>
      <div class='list' v-show='status==3'>
        <a-form-item class="full" :label="$t('admin.appointment.detail.approval.remark')" :colon="false">
          <a-textarea
            maxLength="100"
            disabled
            style="height:160px;"
            v-decorator="['remark', { rules: [{ required: true }] }]"></a-textarea>
        </a-form-item>
      </div>
      <div class="submit-button" v-if='status==1'>
        <a-button type="primary" @click="handleSubmit">{{ $t('admin.appointment.detail.approval.button') }}</a-button>
      </div>
    </a-form>
    <a-modal width="515px" :visible="editShow" @ok="submitEdit" @cancel="editShow = false">
      <a-form :form="formEdit">
        <a-form-item class="full marginBottom0" :label="$t('admin.appointment.detail.modal.opinion')" :colon="false">
          <a-radio-group class="radioGroup" @change="changeColor('navigateBackground')" v-decorator="['status',{ rules: [{ required: true, message: $t('admin.appointment.detail.modal.opinionRequired') }] }]">
            <a-radio :value="2">{{ $t('admin.appointment.detail.modal.approve') }}</a-radio>
            <a-radio :value="3">{{ $t('admin.appointment.detail.modal.reject') }}</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item class="full marginBottom0" :label="$t('admin.appointment.detail.modal.remark')" :colon="false">
          <a-textarea
            maxLength="100"
            :disabled='!isRequired'
            style="height:160px;width: 448px"
            :placeholder="$t('admin.appointment.detail.modal.remarkPlaceholder')"
            v-decorator="['remark', { rules: [{ required: isRequired, message: $t('admin.appointment.detail.modal.remarkRequired') }] }]">
          </a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import cookie from 'js-cookie'

import {
  getTrainingEquipmentDetail,
  postTrainingEquipmentSave,
  teacherSave,
  teacherDetail,
  teacherChangePassword,
  getTrainingEquipmentList,
  getTrainingRoomUsableList,
  getTrainingRoomApplyDetail,
  postTrainingRoomApplyRatify
} from '@/api/admin'
import md5 from 'md5'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  data() {
    return {
      id: undefined,
      form: this.$form.createForm(this),
      itemData:{},
      status:0,
      editShow:false,
      formEdit: this.$form.createForm(this),
      isRequired:false,
    }
  },
  methods: {

    back() {
      // this.$router.push({
      //   name: 'teacherList'
      // })
      this.$router.go(-1);
    },
    handleSubmit(e) {
      e.preventDefault()
      this.editShow = true
      this.formEdit.setFieldsValue({
        status:0,
        remark:'',
      })
    },
    changeColor(key) {
      setTimeout(() => {
        if(this.formEdit.getFieldValue('status')==2){
          this.isRequired = false
        }else{
          this.isRequired = true
        }
      }, )

      this.formEdit[key] = this[key + 'Has'] ? '#ffffff' : ''
      this.isRequired = !this.isRequired;

    },
    // 审批弹框确定
    submitEdit() {
      this.formEdit.validateFields(async (err, values) => {
        if (!err) {
          let param
          if(values.status==2){
            param={
              status:values.status,
              id:this.id
            }
          }else{
            param={...values,...{id:this.id}}
          }
          const res = await postTrainingRoomApplyRatify(param)
          if (res.code === 200) {
            this.editShow = false
            this.getTrainingRoomApplyDetailHttp()
          }
        }
      })
    },
    getTrainingRoomApplyDetailHttp() {
      getTrainingRoomApplyDetail({ id: this.id }).then(res => {
        if (res.code == 200) {
          this.itemData = res.data
          let statusName = res.data.status == 1 ? this.$t('admin.appointment.statusTypes.pending') 
            : res.data.status == 2 ? this.$t('admin.appointment.statusTypes.approved') 
            : res.data.status == 3 ? this.$t('admin.appointment.statusTypes.rejected')
            : res.data.status == 4 ? this.$t('admin.appointment.statusTypes.cancelled') 
            : ''
          let approval = res.data.status == 2 ? this.$t('admin.appointment.detail.approval.agree') 
            : res.data.status == 3 ? this.$t('admin.appointment.detail.approval.disagree') 
            : ''
          this.status = res.data.status
          if(res.data.status==3){
            this.form.setFieldsValue({
              trainingRoomName: res.data.trainingRoomName,
              theme: res.data.theme,
              reservationAt: res.data.reservationAt,
              trainingRoomPlace: res.data.trainingRoomPlace,
              statusName,
              remark: res.data.remark,
              approval,
            })
          }else{
            this.form.setFieldsValue({
              trainingRoomName: res.data.trainingRoomName,
              theme: res.data.theme,
              reservationAt: res.data.reservationAt,
              trainingRoomPlace: res.data.trainingRoomPlace,
              statusName,
            })
          }
        }
      })
    },
    async getTrainingRoomUsableListHttp(){
      const res = await getTrainingRoomUsableList()
      if (res.code == 200) {
        for(let item of res.data.list){
          this.roomList.push({
            name:item.name,
            id:item.id
          })
        }
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    if (this.id) {
      this.getTrainingRoomApplyDetailHttp()
    }
  }
}
</script>

<style lang="less" scoped>
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
.back{
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-top: 16px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #D6D6D6;
  img{
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form{
  .title{
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #EDEDED;
    &::before{
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6B738C;
    }
  }
  .list{
    display: flex;
    //padding-right: 200px;
    .ant-form-item-label label{
      color: #000000;
    }
    .ant-form-item{
      width: 50%;
      padding-left: 45px;
      &:first-child{
        padding-left: 0;
        padding-right: 45px;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix{
      position: absolute;
      img{
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div{
      position: relative;
      .ant-calendar-picker-input{
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #D8DCE0;
      }

    }
    .ant-input,
    .ant-select{
      //border-radius: 20px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select{
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      //border-radius: 20px;
    }
    .ant-input-wrapper.ant-input-group{
      .ant-input{
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon{
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5E7A92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button{
    width: 100%;
    // padding-left: 500px;
    text-align: center;
  }
}
 /deep/ textarea.ant-input {
  resize: none; /* 禁止用户手动拖动调整大小 */
}
/deep/ .ant-form .list .ant-form-item-label label{
  font-weight: 600;
}
.marginBottom0{
  margin-bottom: 0;
}
/deep/ .ant-form-item-children{
  textarea{
    width: 100% !important;
  }
}
</style>
>